<template>
  <div class="tomador-cadastro">
    <Dialog class="tomador-modal" :visible.sync="showCadastroTomador" :modal="true" :closable="false">
      <h1 class="titulo-header">
        {{ headerDialog }}
        <Button
          id="icon-close-modals"
          icon="pi pi-times"
          class="p-button-rounded p-button-text"
          @click="showCadastroTomador = false"
        />
      </h1>
      <div id="topo" class="scrolable-dialog">
        <error-list :erros="erros" />

        <p class="mensagem-edicao" v-if="desabilitarEdicaoEconomico">
          <span>{{ this.mensagemEdicaoTomador }}</span>
        </p>

        <div class="row">
          <div class="col-md-3 mb-2">
            <label for="tipoTomador">Tipo: *</label>
            <span class="p-fluid">
              <Dropdown
                id="tipoTomador"
                v-model="selectedTipoTomador"
                :options="tiposTomador"
                optionLabel="name"
                placeholder="Selecione um Tipo de Tomador"
                @change="limparDadosTomador()"
                :disabled="desabilitarEdicao || desabilitarEdicaoEconomico"
                :optionDisabled="desabilitarEdicao || desabilitarEdicaoEconomico"
              />
            </span>
          </div>

          <div class="col-md-3 mb-2">
            <label for="tipoTomador">{{
              (selectedTipoTomador.key === 'X' ? 'NIF:' : selectedTipoTomador.key === 'F' ? 'CPF:' : 'CNPJ:') + ' *'
            }}</label>
            <span class="p-fluid">
              <template v-if="selectedTipoTomador.key === 'X'">
                <InputText
                  v-model="pessoaTomador.documento"
                  key="X"
                  id="tipoTomador"
                  type="text"
                  :disabled="desabilitarPesquisaCpfCnpj"
                />
              </template>

              <template v-else>
                <div class="p-inputgroup">
                  <template v-if="selectedTipoTomador.key === 'F'">
                    <InputMask
                      @blur="searchContribuintePorCpfCnpj()"
                      v-model="pessoaTomador.documento"
                      key="F"
                      id="tipoTomador"
                      mask="999.999.999-99"
                      placeholder="Pesquisar"
                      :disabled="desabilitarPesquisaCpfCnpj"
                    />
                  </template>
                  <template v-else>
                    <InputMask
                      @blur="searchContribuintePorCpfCnpj()"
                      v-model="pessoaTomador.documento"
                      key="J"
                      id="tipoTomador"
                      mask="**.***.***/****-99"
                      placeholder="Pesquisar"
                      :disabled="desabilitarPesquisaCpfCnpj"
                      style="text-transform: uppercase;"
                    />
                  </template>
                  <Button
                    @click="searchContribuintePorCpfCnpj()"
                    type="button"
                    icon="pi pi-search"
                    class="p-button"
                    title="Pesquisar Contribuinte"
                    :disabled="desabilitarPesquisaCpfCnpj"
                  />
                </div>
              </template>
            </span>
          </div>

          <div class="col-md-4 mb-1" v-if="this.utilizaPesquisaSerpro">
            <label for="tipopessoa">Pesquisar Dados Receita Federal:</label>
            <br />
            <span class="p-fluid">
              <Button
                @click="searchDadosSerpro()"
                type="button"
                icon="pi pi-id-card"
                class="p-button"
                title="Pesquisar Dados Receita Federal"
                :disabled="loading || desabilitarEdicaoEconomico"
              />
            </span>
          </div>

          <div class="col-md-9 mb-2">
            <label for="tipoTomador">Nome: *</label>
            <span class="p-fluid">
              <InputText v-model="pessoaTomador.nome" type="text" :disabled="desabilitarEdicaoEconomico" />
            </span>
          </div>
        </div>

        <div class="row" v-if="selectedTipoTomador.key !== 'X'">
          <div class="col-md-3 mb-2" v-if="selectedTipoTomador.key === 'F'">
            <label for="tipoTomador">RG:</label>
            <span class="p-fluid">
              <InputText v-model="pessoaTomador.rg" type="text" :disabled="desabilitarEdicaoEconomico" />
            </span>
          </div>

          <div class="col-md-6 mb-2" v-if="selectedTipoTomador.key === 'J'">
            <label for="tipoTomador">Nome Fantasia:</label>
            <span class="p-fluid">
              <InputText v-model="pessoaTomador.nomeFantasia" type="text" :disabled="desabilitarEdicaoEconomico" />
            </span>
          </div>

          <div class="col-md-3 mb-2">
            <label for="tipoTomador">Inscrição Estadual:</label>
            <span class="p-fluid">
              <InputText v-model="pessoaTomador.inscEstadual" type="text" :disabled="desabilitarEdicaoEconomico" />
            </span>
          </div>

          <div class="col-md-3 mb-2">
            <label for="tipoTomador">Inscrição Municipal:</label>
            <span class="p-fluid">
              <InputText v-model="pessoaTomador.inscMunic" type="text" :disabled="desabilitarEdicaoEconomico" />
            </span>
          </div>
        </div>

        <hr />

        <template v-if="selectedTipoTomador.key === 'X'">
          <div class="row">
            <div class="col-md-4 mb-2">
              <label for="munic">País: *</label>
              <span class="p-fluid">
                <AutoComplete
                  id="munic"
                  v-model="selectedPais"
                  :dropdown="true"
                  :suggestions="filteredPaises"
                  @complete="searchPais($event)"
                  field="detail"
                  placeholder="Pesquisar"
                />
              </span>
            </div>

            <div class="col-md-8 col-sm-2 mb-2">
              <label for="tipoTomador">Endereço: *</label>
              <span class="p-fluid">
                <InputText v-model="pessoaTomador.logradouro" type="text" />
              </span>
            </div>
          </div>
        </template>

        <template v-else>
          <div class="row d-flex align-items-end">
            <div class="col-md-3 mb-2">
              <label for="tipoTomador">CEP: *</label>
              <span class="p-fluid">
                <div class="p-inputgroup">
                  <InputMask
                    @blur="searchLocalidadePorCep()"
                    v-model="pessoaTomador.cep"
                    mask="99.999-999"
                    placeholder="Pesquisar"
                    :disabled="desabilitarEdicaoEconomico && !habilitarEdicaoEnderecoPetrolina"
                  />
                  <Button
                    @click="searchLocalidadePorCep()"
                    type="button"
                    icon="pi pi-search"
                    class="p-button"
                    title="Pesquisar CEP"
                    :disabled="desabilitarEdicaoEconomico && !habilitarEdicaoEnderecoPetrolina"
                  />
                </div>
              </span>
            </div>

            <div class="col-md-3 mb-2">
              <label for="munic">Município: *</label>
              <span class="p-fluid">
                <AutoComplete
                  id="munic"
                  v-model="selectedMunicipio"
                  :dropdown="true"
                  :suggestions="filteredLocalidades"
                  @item-select="setLocalidades($event)"
                  @complete="searchLocalidade($event)"
                  field="detail"
                  placeholder="Pesquisar"
                  :disabled="desabilitarEdicaoEconomico && !habilitarEdicaoEnderecoPetrolina"
                  :optionDisabled="desabilitarEdicaoEconomico && !habilitarEdicaoEnderecoPetrolina"
                />
              </span>
            </div>

            <div class="col-md-3 mb-2">
              <label for="tipoTomador">Estado:</label>
              <span class="p-fluid">
                <InputText v-model="nomeEstado" type="text" disabled />
              </span>
            </div>

            <div class="col-md-3 mb-2">
              <label for="tipoTomador">País:</label>
              <span class="p-fluid">
                <InputText v-model="nomePais" type="text" disabled />
              </span>
            </div>

            <div class="col-md-3 mb-2">
              <label for="tipoTomador">Bairro: *</label>
              <span class="p-fluid">
                <InputText
                  v-model="pessoaTomador.bairro"
                  type="text"
                  :disabled="desabilitarEdicaoEconomico && !habilitarEdicaoEnderecoPetrolina"
                />
              </span>
            </div>

            <div class="col-md-2 mb-2">
              <label for="tipoTomador">Tipo Logradouro: *</label>
              <span class="p-fluid">
                <InputText
                  v-model="pessoaTomador.tipoLogradouro"
                  type="text"
                  :disabled="desabilitarEdicaoEconomico && !habilitarEdicaoEnderecoPetrolina"
                />
              </span>
            </div>

            <div class="col-md-5 mb-2">
              <label for="tipoTomador">Logradouro: *</label>
              <span class="p-fluid">
                <InputText
                  v-model="pessoaTomador.logradouro"
                  type="text"
                  :disabled="desabilitarEdicaoEconomico && !habilitarEdicaoEnderecoPetrolina"
                />
              </span>
            </div>

            <div class="col-md-2 mb-2">
              <label for="tipoTomador">Número: *</label>
              <span class="p-fluid">
                <InputText
                  v-model="pessoaTomador.numero"
                  type="text"
                  :disabled="desabilitarEdicaoEconomico && !habilitarEdicaoEnderecoPetrolina"
                />
              </span>
            </div>

            <div class="col-md-6 mb-2">
              <label for="tipoTomador">Complemento:</label>
              <span class="p-fluid">
                <InputText
                  v-model="pessoaTomador.complemento"
                  type="text"
                  :disabled="desabilitarEdicaoEconomico && !habilitarEdicaoEnderecoPetrolina"
                />
              </span>
            </div>
          </div>
        </template>

        <hr />

        <div class="row">
          <div class="col-md-3 mb-2">
            <label for="tipoTomador">E-mail:</label>
            <span class="p-fluid">
              <InputText v-model="pessoaTomador.email" type="text" :disabled="desabilitarEdicaoEconomico" />
            </span>
          </div>

          <div class="col-md-3 mb-2">
            <label for="tipoTomador">Site:</label>
            <span class="p-fluid">
              <InputText v-model="pessoaTomador.site" type="text" :disabled="desabilitarEdicaoEconomico" />
            </span>
          </div>

          <div class="col-md-3 mb-2">
            <label for="tipoTomador">Telefone:</label>
            <span class="p-fluid">
              <InputMask
                v-model="pessoaTomador.telefone"
                mask="(99) 9999-9999"
                :disabled="desabilitarEdicaoEconomico"
              />
            </span>
          </div>

          <div class="col-md-3 mb-2">
            <label for="tipoTomador">Celular:</label>
            <span class="p-fluid">
              <InputMask
                v-model="pessoaTomador.celular"
                mask="(99) 99999-999?9"
                :disabled="desabilitarEdicaoEconomico"
              />
            </span>
          </div>
        </div>
      </div>

      <hr />

      <div class="botoes-avancar-voltar">
        <Button
          @click="salvar()"
          href="#topo"
          type="button"
          label="Gravar"
          class="p-button-primary mr-2 p-button-success"
          icon="pi pi-check"
          :disabled="loading"
        />
        <Button
          @click="showCadastroTomador = false"
          type="button"
          label="Fechar"
          class="p-button-primary mr-2 p-button-danger"
          icon="pi pi-times"
        />
      </div>
    </Dialog>

    <Dialog
      class="tomador-modal"
      header="Seleção de Contribuinte"
      :visible.sync="showSelecaoContribuinte"
      :modal="true"
      :closable="false"
    >
      <h1 class="titulo-header">
        Seleção de Contribuinte
        <Button
          id="icon-close-modals"
          icon="pi pi-times"
          class="p-button-rounded p-button-text"
          @click="showSelecaoContribuinte = false"
        />
      </h1>
      <div class="scrolable-dialog selecao-contribuinte">
        <div class="row">
          <DataTable :value="contribuintes" :paginator="true" :rows="5" style="min-width: 100%">
            <Column headerStyle="width: 30%" field="idPessoa.nomeGeral" header="Nome:"></Column>
            <Column headerStyle="width: 20%" field="idPessoa.numeroDocumentoJuridico" header="CPF/CNPJ:"></Column>
            <Column headerStyle="width: 15%" field="inscricaoMunicipal" header="Inscrição Municipal:"></Column>
            <Column headerStyle="width: 25%" field="detailEndereco" header="Endereço:"></Column>
            <Column headerStyle="width: 58px" bodyStyle="text-align: center">
              <template #body="objeto">
                <Button
                  type="button"
                  icon="pi pi-check"
                  title="Selecionar Contribuinte"
                  @click="preencherDadosTomador(objeto.data)"
                ></Button>
              </template>
            </Column>
          </DataTable>
        </div>
      </div>

      <hr />

      <div class="container">
        <div class="row">
          <div>
            <Button
              @click="hideSelecaoContribuinte()"
              type="button"
              label="Fechar"
              class="p-button-primary mr-2 p-button-danger"
              icon="pi pi-times"
            />
          </div>
        </div>
      </div>
    </Dialog>

    <Dialog header="Seleção Endereço" :visible.sync="showSelectLogra" :modal="true" :closable="false">
      <h1 class="titulo-header">
        Seleção Endereço
        <Button
          id="icon-close-modals"
          icon="pi pi-times"
          class="p-button-rounded p-button-text"
          @click="showSelectLogra = false"
        />
      </h1>
      <div class="scrolable-dialog selecao-contribuinte">
        <div class="row">
          <DataTable :value="logradouroList" :paginator="true" :rows="5" style="min-width: 100%">
            <Column field="detail" header="Endereço:"></Column>
            <Column headerStyle="width: 58px" bodyStyle="text-align: center">
              <template #body="objeto">
                <Button
                  type="button"
                  icon="pi pi-check"
                  title="Selecionar"
                  @click="preencherDadosLogradouro(objeto.data)"
                ></Button>
              </template>
            </Column>
          </DataTable>
        </div>
      </div>

      <hr />

      <div class="container">
        <div class="row">
          <div>
            <Button
              @click="showSelectLogra = false"
              type="button"
              label="Fechar"
              class="p-button-primary mr-2 p-button-danger"
              icon="pi pi-times"
            />
          </div>
        </div>
      </div>
    </Dialog>
  </div>
</template>

<script>
import LocalidadeService from '../services/acesso/localidade.service';
import LogradouroService from '../services/acesso/logradouro.service';
import ContribuinteCadastro from '../services/tributario/contribuinte.cadastro.service';
import PaisService from '../services/acesso/pais.service';
import LoginService from '../services/acesso/login.service';
import NfsPessoaService from '../services/nfse/pessoa.service';
import SerproService from '../services/nfse/serpro.service';
import Pessoa from '../models/nfse/Pessoa';
import Util from '../Utils/util';

export default {
  name: 'TomadorCadastro',

  props: {
    tipoEmissao: String,
  },

  data() {
    return {
      loading: false,
      erros: [],
      showCadastroTomador: false,
      showSelecaoContribuinte: false,
      currentUser: null,
      tipoCadastroContribuinte: null,
      pessoaTomador: new Pessoa(),
      contribuintes: [],
      tiposTomador: [
        { name: 'Pessoa Física', key: 'F' },
        { name: 'Pessoa Jurídica', key: 'J' },
        { name: 'Entidade', key: 'E' },
        //{ name: "Exterior", key: "X" },
      ],
      selectedTipoTomador: null,
      filteredLocalidades: null,
      filteredPaises: null,
      selectedMunicipio: null,

      selectedPais: null,
      utilizaPesquisaSerpro: false,
      logradouroList: [],
      showSelectLogra: false,
      telaDaps: false,
      tipoEmissaoInternal: this.tipoEmissao, // Add this line to track tipoEmissao internally,
      modoEdicao: false,
    };
  },

  watch: {
    // Add watcher to sync prop changes with internal data
    tipoEmissao(newValue) {
      this.tipoEmissaoInternal = newValue;
    },
  },

  created() {
    this.$root.$on('notaFiscal:novoTomador', () => {
      this.novoTomador('P');
    });

    this.$root.$on('notaFiscal:novoIntermediario', () => {
      this.novoTomador('I');
    });

    this.$root.$on('notaFiscal:novoDestinatario', () => {
      this.novoTomador('D');
    });

    this.$root.$on('notaFiscal:novoTomadorDaps', () => {
      this.novoTomadorDaps();
    });

    this.$root.$on('notaFiscal:editarTomador', () => {
      this.editarTomador('P');
    });

    this.$root.$on('notaFiscal:editarIntermediario', () => {
      this.editarTomador('I');
    });

    this.$root.$on('notaFiscal:editarDestinatario', () => {
      this.editarTomador('D');
    });

    this.$root.$on('notaFiscal:editarPrestador', () => {
      this.editarDadosPrestador();
    });

    this.currentUser = LoginService.currentUserValue;

    if (this.currentUser.contribuinteConfig.idBolTomadorExterior === 'S') {
      this.tiposTomador.push({ name: 'Exterior', key: 'X' });
    }

    this.selectedTipoTomador = this.tiposTomador[0];
    this.limparDadosTomador();
  },

  methods: {
    // Deverá ser chamado para validação do formulário, antes de salvar
    onSubmit() {
      this.$validate().then((success) => {
        if (success) {
          this.salvar();
        }
      });
    },

    salvar() {
      this.processando(true);

      this.pessoaTomador.idCliente = this.currentUser.usuario.idCliente;
      this.pessoaTomador.idUsuario = this.currentUser.usuario.idUsuario;
      //this.pessoaTomador.idContribuinte = this.pessoaTomador.idContribuinte;

      this.pessoaTomador.edicaoPrestador = null;
      if (this.tipoEmissaoInternal === 'EP') {
        this.pessoaTomador.edicaoPrestador = 'S';
      } else {
        this.pessoaTomador.idContribuintePai = this.currentUser.contribuinte.idContribuinte;
      }

      // Apenas para teste (está gerando ID no lado Server)
      //this.pessoaTomador.id = new Date().getTime().toString();

      this.pessoaTomador.tipo = this.selectedTipoTomador.key;

      if (this.pessoaTomador.tipo === 'X') {
        if (this.selectedPais) {
          this.pessoaTomador.paisCodigoIbge = this.selectedPais.numeroPais;
          this.pessoaTomador.paisNome = this.selectedPais.nomePais;
        }
      } else {
        if (this.selectedMunicipio) {
          this.pessoaTomador.municipioCodigoIbge = this.selectedMunicipio.codigoIbge;
          this.pessoaTomador.municipioNome = this.selectedMunicipio.nomeLocalidade;

          this.pessoaTomador.estadoCodigoIbge = this.selectedMunicipio.estado.codigoIbge;
          this.pessoaTomador.estadoNome = this.selectedMunicipio.estado.nomeEstado;
          this.pessoaTomador.estadoSigla = this.selectedMunicipio.estado.siglaEstado;

          this.pessoaTomador.paisCodigoIbge = this.selectedMunicipio.estado.pais.numeroPais;
          this.pessoaTomador.paisNome = this.selectedMunicipio.estado.pais.nomePais;
        }
      }

      this.erros = [];
      this.pessoaTomador.cepLocalidadeSelecionado = this.selectedMunicipio;
      NfsPessoaService.save(this.pessoaTomador)
        .then(
          (data) => {
            console.log(data);
            this.limparDadosTomador();
            this.showCadastroTomador = false;

            if (this.tipoEmissaoInternal === 'I') {
              this.$parent.selectedPessoaIntermediario = data.data;
              this.$root.$emit('alert:success', 'O Intermediário foi salvo!');
            } else if (this.tipoEmissaoInternal === 'D') {
              this.$parent.selectedPessoaDestinatario = data.data;
              this.$root.$emit('alert:success', 'O Destinatário foi salvo!');
            } else if (this.tipoEmissaoInternal === 'EP') {
              this.$parent.selectedPessoaPrestador = data.data;
              this.$root.$emit('alert:success', 'O Prestador foi salvo!');
            } else {
              this.$parent.selectedPessoa = data.data;
              this.$root.$emit('alert:success', 'O Tomador foi salvo!');
            }

            if (this.telaDaps) {
              this.$parent.atualizarDadosPessoaSelecionada();
            }
          },
          (error) => {
            const erros = error.response.data;
            this.erros.push(...erros);

            if (!this.erros.length) {
              this.$root.$emit('alert:error', 'Houve um problema ao salvar o Tomador!');
            }
          },
        )
        .then(() => {
          this.processando(false);
        });
    },

    searchLocalidade(event) {
      setTimeout(async () => {
        this.filteredLocalidades = await LocalidadeService.findAllByFiltro(event.query);
      }, 250);
    },

    searchLocalidadePorCep() {
      if (this.pessoaTomador.cep !== '') {
        this.processando(true);
        let cep = this.pessoaTomador.cep;
        cep = cep.replace('.', '');
        cep = cep.replace('-', '');
        LogradouroService.findAllByCep(cep)
          .then(
            (response) => {
              if (response.data.length && response.data.length > 1) {
                this.logradouroList = response.data;
                this.showSelectLogra = true;
              } else if (response.data.length > 0) {
                this.selectedLogradouro = response.data[0];
                this.preencherDadosLogradouro(this.selectedLogradouro);
              }
            },
            (error) => {
              let errorMessage = 'Houve um problema ao listar Logradouros!';
              if (error.response) {
                errorMessage = error.response.data;
              }
              this.$toast.add({
                severity: 'error',
                summary: errorMessage,
              });
            },
          )
          .then(() => {
            this.processando(false);
          });
      }
    },

    preencherDadosLogradouro(logradouro) {
      this.processando(true);
      this.pessoaTomador.cep = logradouro.cepLogradouro;
      this.pessoaTomador.bairro = logradouro.nomeBairro;
      this.pessoaTomador.tipoLogradouro = logradouro.nomeTipoLogra;
      this.pessoaTomador.logradouro = logradouro.nomeLogradouro;
      LocalidadeService.findAllById(logradouro.idCepLocalidade)
        .then((response) => {
          this.selectedMunicipio = response.data;
        })
        .then(() => {
          this.processando(false);
          this.showSelectLogra = false;
        });
    },

    searchPais(event) {
      setTimeout(async () => {
        this.filteredPaises = await PaisService.findAllByFiltro(event.query);
      }, 250);
    },

    searchContribuintePorCpfCnpj() {
      const documento = this.pessoaTomador.documento;
      this.utilizaPesquisaSerpro = false;
      if (documento !== '' && this.validarDocumento()) {
        this.processando(true);

        ContribuinteCadastro.findAllByTipoCpfCnpj(documento)
          .then(
            (data) => {
              console.log(data);

              if (data.length) {
                this.contribuintes = data;

                // Se encontrar mais de um cadastro, exibe dialog para selecionar.
                // Se não, já preenche os dados com o contribuinte encontrado.
                if (data.length > 1) {
                  this.showSelecaoContribuinte = true;
                } else {
                  this.preencherDadosTomador(this.contribuintes[0]);
                }
              } else {
                if (this.pessoaTomador.idContribuinte) {
                  this.limparDadosTomador();
                  this.pessoaTomador.documento = documento;
                }
                if (this.currentUser.configuracao.integracaoSerpro == 'S') {
                  this.utilizaPesquisaSerpro = true;
                }
              }
            },
            (error) => {
              if (error.response.data) {
                this.pessoaTomador.documento = null;
                this.$root.$emit('alert:warn', error.response.data);
              } else {
                this.$root.$emit('alert:warn', 'não foi possível consultar o cadastro!');
              }
            },
          )
          .then(() => {
            this.processando(false);
          });
      } else {
        if (this.pessoaTomador.idContribuinte) {
          this.limparDadosTomador();
          this.pessoaTomador.documento = documento;
        }
      }
    },

    preencherDadosTomador(contribuinte) {
      this.hideSelecaoContribuinte();

      this.tipoCadastroContribuinte =
        contribuinte.idContribuinteTipo && contribuinte.idContribuinteTipo.id ? contribuinte.idContribuinteTipo.id : '';

      this.pessoaTomador.id = contribuinte.idPessoa && contribuinte.idPessoa.id ? contribuinte.idPessoa.id : null;
      this.preencherContrTomador(contribuinte);
      this.pessoaTomador.documento = contribuinte.idPessoa.numeroDocumentoJuridico;
      this.pessoaTomador.nome = contribuinte.idPessoa.nomeGeral;
      this.pessoaTomador.nomeFantasia = contribuinte.nomeFantasia;
      this.pessoaTomador.inscMunic = contribuinte.inscricaoMunicipal;
      this.pessoaTomador.inscEstadual = contribuinte.inscricaoEstadual;
      this.pessoaTomador.cep = contribuinte.cep;
      this.selectedMunicipio = contribuinte.idLocalidadeMunicipio;
      this.pessoaTomador.bairro = contribuinte.idBairro ? contribuinte.idBairro.nomeBairro : '';
      this.pessoaTomador.tipoLogradouro =
        contribuinte.idLogradouro && contribuinte.idLogradouro.idCepTipoLogra
          ? contribuinte.idLogradouro.idCepTipoLogra.nomeTipoLogra
          : '';
      this.pessoaTomador.logradouro = contribuinte.idLogradouro ? contribuinte.idLogradouro.nomeLogradouro : '';
      this.pessoaTomador.numero = contribuinte.numeroLogradouro;
      this.pessoaTomador.complemento = contribuinte.complementoLogradouro;
      this.pessoaTomador.idCepLocalidade = contribuinte.idLocalidadeMunicipio
        ? contribuinte.idLocalidadeMunicipio.id
        : null;

      this.pessoaTomador.email = contribuinte.contatos.email;
      this.pessoaTomador.site = contribuinte.contatos.site;
      this.pessoaTomador.telefone = contribuinte.contatos.telefone;
      this.pessoaTomador.celular = contribuinte.contatos.celular;

      if (
        this.pessoaTomador.idContribuinte &&
        contribuinte.idContribuinteTipo.id == this.currentUser.configuracao.idContrTipoEconomico
      ) {
        this.$root.$emit('alert:warn', this.mensagemEdicaoTomador);
      }
    },

    preencherContrTomador(contribuinte) {
      //pessoa fisica porto velho permite edição tomador
      if (
        this.currentUser.usuario.idCliente === '8051f762-e8f9-487c-b537-4b2ce582c5e9' &&
        contribuinte.idPessoa &&
        contribuinte.idPessoa.numeroDocumentoJuridico &&
        contribuinte.idPessoa.numeroDocumentoJuridico.length <= 14
      ) {
        return;
      } else if (
        contribuinte.idContribuinteTipo &&
        contribuinte.idContribuinteTipo.id == this.currentUser.configuracao.idContrTipoEconomico
      ) {
        this.pessoaTomador.idContribuinte = contribuinte.id;
      }
    },

    setLocalidades(event) {
      this.selectedMunicipio = event.value;
    },

    novoTomador(tipoEmissao) {
      this.modoEdicao = false;
      this.tipoEmissaoInternal = tipoEmissao; // Use internal data instead of prop
      this.limparDadosTomador();
      this.selectedTipoTomador = this.tiposTomador[0];
      this.showCadastroTomador = true;
      this.telaDaps = false;
    },

    novoTomadorDaps() {
      this.modoEdicao = false;
      this.limparDadosTomador();
      this.selectedTipoTomador = this.tiposTomador[0];
      this.showCadastroTomador = true;
      this.telaDaps = true;
    },

    editarTomador(tipoEmissao) {
      this.modoEdicao = true;
      this.tipoEmissaoInternal = tipoEmissao;
      this.limparDadosTomador();
      // Carrega o objeto pessoa da tela de Emissão de Nota
      if (this.tipoEmissaoInternal === 'I') {
        this.pessoaTomador = this.$parent.selectedPessoaIntermediario;
      } else if (this.tipoEmissaoInternal === 'D') {
        this.pessoaTomador = this.$parent.selectedPessoaDestinatario;
      } else {
        this.pessoaTomador = this.$parent.selectedPessoa;
      }

      this.processando(true);
      //Carrega o Tipo de Cadastro
      setTimeout(async () => {
        await ContribuinteCadastro.findTipoCadastroContribuinte(
          this.pessoaTomador.documento,
          this.pessoaTomador.inscMunic,
        )
          .then((data) => {
            if (data) {
              this.tipoCadastroContribuinte = data.data.tipoCadastroContribuinte;
              var vigenteNfse = data.data.vigenteNfse;
              //pessoa fisica porto velho permite edição tomador
              if (
                this.currentUser.usuario.idCliente === '8051f762-e8f9-487c-b537-4b2ce582c5e9' &&
                this.pessoaTomador.documento &&
                this.pessoaTomador.documento.length <= 14
              ) {
                this.pessoaTomador.idContribuinte = null;
              } else if (!vigenteNfse || vigenteNfse !== 'S') {
                this.pessoaTomador.idContribuinte = null;
              }
            }
          })
          .then(() => {
            // Carrega o Tipo do Tomador
            var keyTipo = this.pessoaTomador.tipo;
            this.selectedTipoTomador = this.tiposTomador.filter((tipo) => tipo.key == keyTipo)[0];

            if (keyTipo == 'X') {
              // Carrega dados do endereço (exterior)
              PaisService.findAllByFiltro(this.pessoaTomador.paisCodigoIbge).then((data) => {
                if (data.length) {
                  this.selectedPais = data[0];
                }
              });
            } else {
              // Carrega dados do endereço
              LocalidadeService.findAllByFiltro(this.pessoaTomador.municipioCodigoIbge).then((data) => {
                if (data.length) {
                  this.selectedMunicipio = data[0];
                }
              });
            }

            this.showCadastroTomador = true;
            this.processando(false);
          });
      }, 250);
    },

    editarDadosPrestador() {
      this.modoEdicao = true;
      this.limparDadosTomador();
      this.tipoEmissaoInternal = 'EP'; //edicao de prestador
      // Carrega o objeto pessoa da tela de Emissão de Nota
      this.pessoaTomador = this.$parent.selectedPessoaPrestador;
      this.processando(true);

      // Carrega o Tipo do Tomador
      var keyTipo = this.pessoaTomador.tipo;
      this.selectedTipoTomador = this.tiposTomador.filter((tipo) => tipo.key == keyTipo)[0];

      if (keyTipo == 'X') {
        // Carrega dados do endereço (exterior)
        PaisService.findAllByFiltro(this.pessoaTomador.paisCodigoIbge).then((data) => {
          if (data.length) {
            this.selectedPais = data[0];
          }
        });
      } else {
        // Carrega dados do endereço
        LocalidadeService.findAllByFiltro(this.pessoaTomador.municipioCodigoIbge).then((data) => {
          if (data.length) {
            this.selectedMunicipio = data[0];
          }
        });
      }

      this.showCadastroTomador = true;
      this.processando(false);
    },

    searchDadosSerpro() {
      const documento = this.pessoaTomador.documento;
      if (documento !== '' && this.validarDocumento()) {
        this.processando(true);

        SerproService.findByDocumento(this.currentUser.usuario.idCliente, documento)
          .then(
            (response) => {
              console.log(response.data);
              this.pessoaTomador.nome = response.data.nome_empresarial
                ? response.data.nome_empresarial
                : response.data.nome;
              this.pessoaTomador.nomeFantasia = response.data.nome_fantasia ? response.data.nome_fantasia : '';
              this.pessoaTomador.nomeFantasia = response.data.nome_fantasia ? response.data.nome_fantasia : '';
              if (response.data.endereco) {
                if (response.data.endereco.cep) {
                  this.pessoaTomador.cep = response.data.endereco.cep;
                  this.searchLocalidadePorCep();
                }
                this.pessoaTomador.numero = response.data.endereco.numero ? response.data.endereco.numero : '';
                this.pessoaTomador.complemento = response.data.endereco.complemento
                  ? response.data.endereco.complemento
                  : '';
                if (response.data.endereco.logradouro) {
                  let endereco = response.data.endereco.logradouro.split(' ');
                  this.pessoaTomador.tipoLogradouro = endereco[0];
                  this.pessoaTomador.logradouro = response.data.endereco.logradouro.replace(endereco[0], '');
                }
                if (response.data.endereco.bairro) {
                  this.pessoaTomador.bairro = response.data.endereco.bairro;
                }
              }
            },
            (error) => {
              console.log(error);
              this.$root.$emit('alert:warn', error.response.data);
            },
          )
          .then(() => {
            this.processando(false);
          });
      }
    },

    hideSelecaoContribuinte() {
      this.limparDadosTomador();
      this.showSelecaoContribuinte = false;
    },

    limparDadosTomador() {
      this.pessoaTomador = new Pessoa();
      this.selectedMunicipio = null;
      this.selectedPais = null;
      this.tipoCadastroContribuinte = null;
      this.erros = [];
    },

    processando(show) {
      if (show) {
        this.loading = true;
        this.$root.$emit('loading:show');
      } else {
        this.loading = false;
        this.$root.$emit('loading:hide');
      }
    },

    validarDocumento() {
      var validar = false;
      validar = Util.validarCPFCNPJ(this.pessoaTomador.documento);

      if (!validar) {
        console.log(validar);
        this.$root.$emit('alert:error', 'CPF/CNPJ ' + this.pessoaTomador.documento + ' inválido!');
        this.pessoaTomador.documento = null;
      }
      return validar;
    },
  },

  computed: {
    desabilitarEdicaoEconomico() {
      if (this.pessoaTomador && this.pessoaTomador.id) {
        return this.pessoaTomador.idContribuinte &&
          this.tipoCadastroContribuinte &&
          this.tipoCadastroContribuinte == this.currentUser.configuracao.idContrTipoEconomico
          ? true
          : false;
      } else {
        return this.pessoaTomador && this.pessoaTomador.idContribuinte ? true : false;
      }
    },

    desabilitarEdicao() {
      return !!(this.pessoaTomador && this.pessoaTomador.idContribuintePai);
    },

    desabilitarPesquisaCpfCnpj() {
      return !!(
        (this.desabilitarEdicao || this.desabilitarEdicaoEconomico || this.tipoEmissaoInternal === 'EP') &&
        this.pessoaTomador &&
        this.pessoaTomador.id !== ''
      );
    },

    habilitarEdicaoEnderecoPetrolina() {
      //093560/2024 - Petrolina: Liberar edição de endereço quando for PF; OU for PJ do Cadastro Econômico de fora do municipio.
      if (this.currentUser.usuario.idCliente === '3d6adeff-3f83-4033-8b16-3f5d42fccd1a') {
        const cepLocalidadeTomador = this.pessoaTomador.idCepLocalidade;
        const cepLocalidadeCliente = this.currentUser.configuracao.idCepLocalidadeCliente;
        const tipoCadastroContribuinte = this.tipoCadastroContribuinte;
        const tipoCadastroEconomico = this.currentUser.configuracao.idContrTipoEconomico;
        const tipoPessoa = this.selectedTipoTomador.key;

        return (
          tipoPessoa === 'F' ||
          (tipoCadastroContribuinte === tipoCadastroEconomico && cepLocalidadeTomador !== cepLocalidadeCliente)
        );
      }
      return false;
    },

    mensagemEdicaoTomador() {
      if (this.habilitarEdicaoEnderecoPetrolina) {
        return 'O contribuinte informado é do Tipo Econômico. Os dados não podem ser alterados, com exceção do endereço.';
      } else {
        return 'O contribuinte informado é do Tipo Econômico. Os dados não podem ser alterados.';
      }
    },

    nomeEstado() {
      return this.selectedMunicipio && this.selectedMunicipio.estado ? this.selectedMunicipio.estado.detail : '';
    },

    nomePais() {
      return this.selectedMunicipio && this.selectedMunicipio.estado && this.selectedMunicipio.estado.pais
        ? this.selectedMunicipio.estado.pais.detail
        : '';
    },

    headerDialog() {
      return (
        (this.modoEdicao ? 'Edição de ' : 'Cadastro de ') +
        (this.tipoEmissaoInternal == 'I'
          ? 'Intermediário'
          : this.tipoEmissaoInternal == 'D'
          ? 'Destinatário'
          : this.tipoEmissaoInternal == 'T' || this.tipoEmissaoInternal == 'EP'
          ? 'Prestador'
          : 'Tomador')
      );
    },
  },
};
</script>

<style scoped>
.scrolable-dialog {
  padding-right: 25px;
  width: 90vw;
  max-height: 65vh;
  overflow-y: auto;
  overflow-x: hidden;
}

.selecao-contribuinte {
  width: 80vw;
}

.mensagem-edicao {
  color: red;
  font-weight: bold;
}
</style>
